import React from 'react';
import { withStyles } from "tss-react/mui";
import isNotNullOrEmpty from 'utilities/is/isNotNullOrEmpty';
import Divider from '@mui/material/Divider';
import { H2, Body1 } from 'components/Typography';
import styles from './styles';
import m from 'messages';

function CscsCards(props) {

    const { card, classes } = props;
    const hasCscsCards = isNotNullOrEmpty(card.cscsCards);
    return (
        <div className={classes.fullWidth}>
            {hasCscsCards &&
                <div className={classes.container}>
                    <H2 paragraph>
                        {m.cards.cscsCardsTitle}
                    </H2>
                    <div className={classes.body}>
                        {card.cscsCards.map((c, index) =>
                            <React.Fragment key={index}>
                                <Body1 paragraph>
                                    {c.cscsCardSchemeName} - {c.cscsCardType}
                                </Body1>
                                <Divider />
                            </React.Fragment>
                        )}
                    </div>
                </div>
            }
        </div>
    );
}

export default withStyles(CscsCards,styles);